// extracted by mini-css-extract-plugin
module.exports = {"timeline":"SemanticTimeline--timeline","fitButton":"SemanticTimeline--fitButton","loading":"SemanticTimeline--loading"};